import zoneIllustration from '../static/images/sectionTalking/2016/zone-illustration.png';
import zonePhoto from '../static/images/sectionTalking/2016/img-zone.png';
import lichinIllustration from '../static/images/sectionTalking/2016/lichin-illustration.png';
import lichinPhoto from '../static/images/sectionTalking/2016/img-lichin.png';
import tsengIllustration from '../static/images/sectionTalking/2016/tseng-illustration.png';
import tsengPhoto from '../static/images/sectionTalking/2016/img-tseng.png';
import seanIllustration from '../static/images/sectionTalking/2016/sean-illustration.png';
import seanPhoto from '../static/images/sectionTalking/2016/img-sean.png';
import debbyIllustration from '../static/images/sectionTalking/2016/debby-illustration.png';
import debbyPhoto from '../static/images/sectionTalking/2016/img-debby.png';
import hsiaoIllustration from '../static/images/sectionTalking/2016/yutung-illustration.png';
import hsiaoPhoto from '../static/images/sectionTalking/2016/img-yutung.png';
import willyIllustration from '../static/images/sectionTalking/2016/willy-illustration.png';
import willyPhoto from '../static/images/sectionTalking/2016/img-willy.png';

export default [
    {
        name: "ZONE",
        position: "Back-End Developer",
        img: zoneIllustration,
        photo: zonePhoto,
        article: `
<p>
安安大家好 我是 25sprout 最胖最腫的後端實習生 - 腫言
</p>

<p>
時間很快，在 25sprout 一年的實習一轉眼就過去了，\
回想面試的那天就彷彿是昨天發生的事情。
</p>

<p>
這一年接觸許多的案子，我的 mentor - Mike 也放心的讓我去在專案上的嘗試，\
時常給我寫 Code 很好的建議，也很尊重我的想法，更會跟我分享新的且好用的工具，\
他是我的一盞明燈 XDD
</p>

<p>
我也是在新芽第一個成功免役的人，在邁向免役的道路上，\
大家也給我很多支持與協助，狂餵我吃零食和把午餐的肉分給我吃。
</p>

<p>
今年大家也開始注重健康，於是有了籃球社、羽球社、踢拳社、吉他社，\
每天都有不一樣的社團活動，一整個很健康，讓大家上班之餘還可以跟同事們交流感情。
</p>

<p>
在 25sprout 最開心的是同事們不像同事，而更像是我的夥伴，一起完成一件大事的夥伴 🚀🚀🚀
</p>`        
    },
    {
        name: "LICHIN",
        position: "Front-End Developer",
        img: lichinIllustration,
        photo: lichinPhoto,
        article: `
<p>嗨大家好! 我是最年輕的實習生 Lichin</p>

<p>
在新芽工作的日子呢是非常寶貴的，由於我還是大三學生，\
一週只能到公司一天，每次都要起個大早搭上客運，再轉車到公司。\
不過即使交通是那麼的惱人，我還是很愛來上班，\
畢竟公司裡的哥哥姊姊都很熱情的對待人，\
另外也還有來自各國的美味零食、遊戲區可以在打 code 之餘放鬆一下。
</p>

<p>
這裡可能還不是技術最厲害的公司，但卻是一間非常重視員工的公司。\
在這個水平化的組織中，每一個人的聲音都會被聽到、都會被考慮到，並實際被採用。\
雖然，大多是的時間我都沒有開口哈哈哈哈。\
但是這樣難得的公司文化真的令我非常嚮往，也是在進來公司後常常跟同學說嘴~~
</p>

<p>
最後，謝謝自己在20歲的時候有勇氣決定來實習，\
跟著一群會講垃圾話但是又很有熱誠、厲害的夥伴一起進步、\
用程式碼幫助社會甚至讓世界變得更美好。
</p>

<p>
如果你也想加入新芽這個大家庭，擁有除了當宅宅打 code 之外滿滿的回憶，\
就不要再猶豫了，一起成為 Sprouter 吧!
</p>`
    },
    {
        name: "TSENG",
        position: "Project / Marketing",
        img: tsengIllustration,
        photo: tsengPhoto,
        article: `
<p>
對於一個大學讀財金、文組不意外的我來說，能進到這間兩年前就一直關注，\
卻始終不敢投履歷的的網路公司實習，對我來說還是件難以想像的事情。\
我想如果去年我沒鼓起勇氣投履歷，現在應該是個已退役男，且沒發胖的在金融業找工作吧。
</p>

<p>
在過去實習的期間，最有收穫的除了一開始跟著 PM 見客戶開會談需求提案，\
到後來協助 Marketing 做內容行銷、數據追蹤和競品分析外，\
我想大概就是和同事的相處了吧。
</p>

<p>
除了有事沒事講講垃圾話很療癒外，每次遇到任何問題，\
都可以找到人尋求建議和幫忙，這對還不熟悉網路產業的我來說，真的是個非常棒的學習環境。
</p>

<p>
很高興自己能過喜歡的生活，每天都學習到新東西的感覺真的很棒。\
公司的福利應該也不用我多說，如果你喜歡我們的工作環境，歡迎加入我們投出履歷吧！
</p>

<p>「哦對了，記得來註冊使用企業級的雲端問卷服務 SurveyCake」</p>`
    },
    {
        name: "SEAN",
        position: "Growth Hacker",
        img: seanIllustration,
        photo: seanPhoto,
        article: `
<p>
還記得原本投履歷來面試新芽，是為了能練習前端的網頁語言，\
想不到面試完才發現自己離專業的前端們實在相差太遠了。\
但面試時我記得 Alex 問我，為何我想練習前端的網頁語言？\
我說，因為我認為一位 Growth Hacker 就是要能有一些自己開發的能力；\
接著他馬上又問了我覺得什麼是 Growth Hacking，\
於是我就開始在大家面前大聊我所認為的 Growth Hacking 了。
</p>

<p>
然後就這樣輾轉來到新芽的 SurveyCake 做行銷實習了。
</p>

<p>
礙於一些個人因素，我知道我能來辦公室的時間並不多，\
但 Alex 仍然願意給我機會讓我嘗試，甚至還因此就這樣遇到了自己大學的學弟\
（世界真小啊！！），我們兩個就這樣成為了 SurveyCake Marketing Team 的成員。\
常常遠端工作的我，雖然沒有幫上 SurveyCake 太多忙，\
但也誤打誤撞試了很多行銷方法、寫文章媒體跟建立數據追蹤系統。\
到後來有 Daniel 系統性的帶領，\
帶著我們和 SurveyCake 一步一步走向企業級雲端問卷的王者之路。\
其中最讓我印象深刻的是怎麼制定一個產品的價格來藉機行銷產品、\
怎麼觀測並判讀真正會影響決策的數據是什麼、\
怎麼有條有序地慢慢的將行銷團隊該做的\
例行公事和團隊資源建立起來。\
</p>

<p>
撇除工作之外，在新芽最歡樂的就是不停的聚餐跟下班後的社團活動了，\
桌遊、Party、運動飆汗，在這裡真的不只是工作與學習，\
更是認識了一群很棒的朋友！你會看到大家不管上班還是下班都膩在一起， 
誰說同事只是同事呢？所以不管你是想要學習新事物新技術、 
想要玩樂結交朋友、想要工作賺錢，\
新芽絕對都是你實習最好的選擇！
</p>`
    },
    {
        name: "DEBBY",
        position: "Project / Marketing",
        img: debbyIllustration,
        photo: debbyPhoto,
        article: `
<p>
在新芽實習的這段時間，一定是這輩子最值得回味的日子之一。
</p>

<p>
有幸進到福利羨煞眾人的公司，除了吃喝玩都很滿足外，\
這段時間的個人成長真的不曾停滯過（我不是說體重）。
</p>

<p>
作為一個沒什麼行銷實務經驗的菜鳥、又對程式一竅不通的文組生，\
剛進去沒多久就深深體會到：天啊！大家都好強！每個人都身懷絕技、\
有好多好多的東西。但更重要的是，大家都不吝於互相分享、學習。\
在這樣的環境下，你會不斷吸收新的資訊、不斷激勵自己成長。只怕自己不想學，\
不然這兒能給你的東西是永遠學不完的。
</p>

<p>
除了在工作上不斷精進之外，\
最喜歡的就是和哥哥姐姐以及實習夥伴們一起相處的時光。（\
每天都坐一圈一起吃飯，雖然常常笑到消化不良就是了）\
新芽就是有這種魅力，在工作上是最棒的趴呢，生活中也逐漸變成不可或缺的夥伴。\
</p>

<p>
快來吧，能有正向的壓力去督促自己成長之餘、還有源源不絕的資源提供身心\
靈的補給，也就只有新芽了。
</p>`
    },
    {
        name: "HSIAO",
        position: "Front-End Developer",
        img: hsiaoIllustration,
        photo: hsiaoPhoto,
        article: `
<p>
大四快結束的時候很徬徨不知道未來該怎麼辦，\
不知道應該要先工作還是繼續念書，因為一直猶豫不決，\
所以最後決定先延畢一年，再上一點想上的課，\
然後找一份實習，到處學學到處看看。\
九月的時候剛好知道新芽在徵前端實習生，就這樣很幸運的進了新芽。\
</p>

<p>
在新芽我學了好多東西，在這裡可以實際參與正式的專案，\
也有很多的空間可以自主學習，遇到問題大家也都會很熱心幫忙解惑，跟剛進來的時候比起來，\
我真的進步了很多。一開始我只會基本的 html css跟一點點的 js，現在開始\
會用 webpack, es6, vue開發，目前也正在用 vue 開發專案 (這個實習生網站)。\
</p>

<p>
至於這裡的福利有多好就不多說了，大家每天中午一起吃飯，\
下班後各種的社團活動，還有每一季固定的電影之夜，在這裡同事就像朋友一樣的存在。\
</p>

<p>如果你也喜歡新芽的環境，就投出履歷吧!</p>`
    },
    {
        name: "WILLY",
        position: "APP Developer",
        img: willyIllustration,
        photo: willyPhoto,
        article: `
<p>
我是在 2016 年底才加入的 Android 實習生，\
很開心終於可以在畢業的前夕進到已經肖想很久的公司，\
不枉費我努力不懈的投了兩三次履歷嗚嗚嗚。\
</p>

<p>
這邊的工作環境很開放，帶我的 Mentor 叫做小馬，雖然看起來兇兇的，\
但其實人真的很好也很照顧我，我們會一起討論專案要怎麼進行，\
或是要如何實作等等。空閒時也會讓我去研究一些目前還沒有碰過的新技術。\
讓我有很大的空間可以自由發揮，不會感覺自己只是個小齒論只能照著指令轉動～
</p>

<p>
其他福利我想網路上都寫得夠多了我就不一一細數，\
但我最喜歡的就是今年開始的社團活動了！\
一個禮拜大概有一半的晚上都在參加社團活動，\
比我大學參加的社團還要多XDD，也因此大家在相處上比起同事，\
其實真的更像是朋友一樣，一起學習一起成長一起玩<s>一起魯</s>。
</p>

<p>
雖然在新芽的日子只有短短的三個多月，但我想我會永遠記得這裡的垃圾話\
與魯蛇夥伴們。
</p>`
    }
]



// WEBPACK FOOTER //
// ./src/models/Sprouters2016.js